import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
const verticalLabelStyles = css `
  flex-direction: column-reverse;
  align-items: center;
`;
const spacingFromSize = {
    small: 'spacing.md',
    medium: 'spacing.lg',
};
export const Label = styled.label `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${themeGet('spacing.md')};
  padding: ${({ $size }) => themeGet(spacingFromSize[$size])};
  border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.gray.0')};
  transition: all 0.1s;

  ${({ $alignment }) => $alignment === 'vertical' && verticalLabelStyles};
  ${({ $invalid }) => css `
    border-color: ${$invalid ? themeGet('colors.red.500') : themeGet('colors.border.100')};

    &:hover:not(:has(input:disabled)) {
      border-color: ${$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.1000')};
      box-shadow: ${themeGet('dropShadow.400')};
    }

    &:has(input:checked) {
      border-color: ${$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.1000')};
      background-color: ${$invalid ? themeGet('colors.red.50') : themeGet('colors.primary.50')};
    }

    &:has(input:focus-visible) {
      border-color: ${$invalid ? themeGet('colors.focus.danger') : themeGet('colors.focus.primary')};
      outline: ${pxToRem(3)} solid ${$invalid ? themeGet('colors.focus.danger') : themeGet('colors.focus.primary')};
      box-shadow: ${themeGet('dropShadow.400')};
    }

    &:has(input:active):not(:has(input:disabled)) {
      border-color: ${$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.1000')};
      background-color: ${$invalid ? themeGet('colors.red.100') : themeGet('colors.primary.100')};
      box-shadow: ${themeGet('dropShadow.400')};
    }

    &:has(input:disabled) {
      opacity: 0.5;
      box-shadow: none;
    }
  `};
`;
const verticalInputStyles = css `
  align-self: flex-end;
`;
export const InputOverlay = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  flex: 0 0 ${pxToRem(20)};
  background-color: ${themeGet('colors.background.50')};
  border: ${pxToRem(1)} solid ${themeGet('colors.border.200')};
  border-radius: ${({ $type }) => ($type === 'radio' ? themeGet('borderRadius.circle') : themeGet('borderRadius.sm'))};
  ${({ $alignment }) => $alignment === 'vertical' && verticalInputStyles};
  ${({ $invalid }) => css `
    input:checked + & {
      border-color: transparent;
      background-color: ${$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.1000')};
    }
  `}
`;
export const HiddenInput = styled.input `
  width: 0;
  height: 0;
  opacity: 0;
`;
